/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExcelConnectionConfigList } from '../../models/excel-connection-config-list';

export interface ListExcelConnectionConfigurations$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;
}

export function listExcelConnectionConfigurations(http: HttpClient, rootUrl: string, params: ListExcelConnectionConfigurations$Params, context?: HttpContext): Observable<StrictHttpResponse<ExcelConnectionConfigList>> {
  const rb = new RequestBuilder(rootUrl, listExcelConnectionConfigurations.PATH, 'get');
  if (params) {
    rb.path('uid', params.uid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ExcelConnectionConfigList>;
    })
  );
}

listExcelConnectionConfigurations.PATH = '/stations/{uid}/excel';
